<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-05 15:40:59
 * @FilePath: /mrc-ess-fronted/src/Layout/SystemErrorPage.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-02-24 18:31:27
-->
<template>
  <v-container
    class="
      max-width
      d-flex
      flex-grow-1
      ma-0
      pa-0
      fill-height
      flex-column
      justify-center
      text-center
      align-center align-self-center
    "
    :elevation="0"
    style="min-height: 500px"
    fluid
  >
    <div>
      <svg-icon size="200" iconClass="Error_Maintenance" />
      <div class="text-h5 text--secondary">
        {{ $t("message_essweb_system_message_systemErrorLabel") }}
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
  name: "SystemErrorPage",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
</style>